var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdevbasarili(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 3.2V0H8.13334V3.2H0V14.4C0 16.16 1.464 17.6 3.25333 17.6H8.296C8.94667 20.736 11.4517 23.2 14.64 23.84V27.328C9.76 28.064 9.76 32 9.76 32H22.7733C22.7733 32 22.7733 28.064 17.8933 27.328V23.84C21.0816 23.2 23.5867 20.736 24.2373 17.6H29.28C31.0693 17.6 32.5333 16.16 32.5333 14.4V3.2H24.4ZM3.25333 14.4V6.4H8.13334V14.4H3.25333ZM29.28 14.4H24.4V6.4H29.28V14.4Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdevbasarili);
export default __webpack_public_path__ + "static/media/odevbasarili.66825e45e1f750ca2e80079d0d5897bc.svg";
export { ForwardRef as ReactComponent };